var React = require('react');
var Griddle = require('griddle-react');

var RequestPaymentCourierStatus = require('../../../containers/Admin/Requests/RequestPaymentCourierStatus');
var DateFormatter = require('../../../containers/Formatters/DateFormatter');
var EstimatedTimeFormatter = require('../../../containers/Formatters/EstimatedTimeFormatter');
var PriceFormatter = require('../../../containers/Formatters/PriceFormatter');

var FormGroup = require('react-bootstrap/lib/FormGroup');
var DatePicker = require("react-bootstrap-date-picker");

require('./request.css');

var PaymentMethod = React.createClass({

	getType: function(fgType) {
		return fgType === 0 ? "Transferência" : (fgType === 1 ? "MercadoPago" : (fgType === 3 ? "Dinheiro" : "Boleto"));
	},

	render: function(){
		var me = this, 
			data = me.props.data;

		return <span>{me.getType(data)}</span>
	}

});

const rowData = [
	{
    	"columnName": "id",
    	"order": 1,
    	"visible": false
	},
	{
		"columnName": "createdAt",
		"order": 2,
		"visible": true,
		"displayName": "Data",
		"customComponent": DateFormatter,
		"sortable": false
	},
	{
		"columnName": "order",
		"order":  3,
		"visible": true,
		"displayName": "Pedido",
		"sortable": false
	},
	{
		"columnName": "nameCourier",
		"order": 4,
		"visible": true,
		"displayName": "Entregador",
		"sortable": false
	},
	{
		"columnName": "phoneCourier",
		"order": 5,
		"visible": true,
		"displayName": "Telefone",
		"sortable": false
	},
	{
		"columnName": "nameClient",
		"order": 6,
		"visible": true,
		"displayName": "Cliente",
		"sortable": false
	},
	{
		"columnName": "phoneClient",
		"order":  7,
		"visible": true,
		"displayName": "Telefone",
		"sortable": false
	},
	{
		"columnName": "aPoint",
		"order":  8,
		"visible": true,
		"displayName": "Ponto A",
		"sortable": false
	},
	{
		"columnName": "bPoint",
		"order":  9,
		"visible": true,
		"displayName": "Ponto B",
		"sortable": false
	},
	{
		"columnName": "cPoint",
		"order":  10,
		"visible": true,
		"displayName": "Ponto C",
		"sortable": false
	},
	{
		"columnName": "dPoint",
		"order":  11,
		"visible": true,
		"displayName": "Ponto D",
		"sortable": false
	},
	{
		"columnName": "returnToOrigin",
		"order":  12,
		"visible": true,
		"displayName": "Retorno solicitado",
		"sortable": false
	},
	{
    	"columnName": "estimatedTime",
    	"order": 13,
    	"visible": true,
    	"displayName": "Tempo estimado",
    	"sortable": false,
    	"customComponent": EstimatedTimeFormatter
	},
	{
    	"columnName": "paymentMethod",
    	"order": 14,
    	"visible": true,
    	"displayName": "Pagamento",
    	"sortable": false,
    	"customComponent": PaymentMethod
	},
	{
		"columnName": "value",
    	"order": 15,
    	"visible": true,
    	"displayName": "Valor",
    	"sortable": false,
    	"customComponent": PriceFormatter
	},
	{
		"columnName": "courierValue",
    	"order": 16,
    	"visible": true,
    	"displayName": "Valor Entregador",
    	"sortable": false,
    	"customComponent": PriceFormatter
	},
	{
    	"columnName": "paymentCourierStatus",
    	"order": 17,
    	"visible": true,
    	"displayName": "Pagamento Entregador",
    	"sortable": false,
    	"customComponent": RequestPaymentCourierStatus
	}
];

var List = React.createClass({

	getInitialState: function() {
		return {
			timestamp: Date.now(),
			start: '',
			end: ''
		}
	},

	startHandleChange: function(value, formattedValue) {
		if(value == null) {
			this.state.start = 0;
		} else {
			formattedValue=formattedValue.split("/");
			var newDate=formattedValue[1]+","+formattedValue[0]+","+formattedValue[2];
			value = new Date(newDate).getTime();
		    this.state.start = value;
		}
	},

	endHandleChange: function(value, formattedValue) {
		if(value == null) {
			this.state.end = 0;
		} else {
			formattedValue=formattedValue.split("/");
			var newDate=formattedValue[1]+","+formattedValue[0]+","+formattedValue[2];
			value = new Date(newDate).getTime();
		    this.state.end = value;
		}
	},

	componentDidUpdate: function(){
		var hiddenInputElement = document.getElementById("grid");
	},

	customFilterFunction: function(items, query) {
		var start = Number(this.state.start);
		var end = Number(this.state.end) + 86399999;
		return items.filter(item => {
			var nameClient = String(item.nameClient);
			var nameCourier = String(item.nameCourier);
			if(item.createdAt >= start || Number(this.state.start) == 0) {
				if(item.createdAt <= end || Number(this.state.end) == 0) {
					if(nameClient.toUpperCase().indexOf(query.toUpperCase()) > -1 || nameCourier.toUpperCase().indexOf(query.toUpperCase()) > -1) {
						return true;
					}
				}
			}

			return false;
		});
	},

	render: function() {
		var me = this;

		return (
			<div>
				<div id="filters">
					<table id="filtersTable">
						<tr>
							<td>
			            		<table><tr><td>Inicio:</td><td><DatePicker id="start" onChange={this.startHandleChange} /></td></tr></table>
			        		</td>
			        		<td id="td2">
			            		<table><tr><td>Fim:</td><td><DatePicker id="end" onChange={this.endHandleChange} /></td></tr></table>
			        		</td>
			        	</tr>
			        </table>
				</div>
                <Griddle
                	id="grid"
					results={me.props.data}
					columnMetadata={rowData}
					showFilter={true}
					useCustomFilterer={true}
					customFilterer={me.customFilterFunction}
					resultsPerPage={20}
					useGriddleStyles={false}
					tableClassName="table"
					sortDefaultComponent={<span className="icon-sort"></span>}
					sortAscendingComponent={<span className="icon-sort-down"></span>}
					sortDescendingComponent={<span className="icon-sort-up"></span>}
					filterPlaceholderText="Pesquisar entregador ou cliente"
					nextText="Próxima"
					previousText="Anterior"
					columns={[
						"createdAt", 
						"order",
						"nameCourier", 
						"phoneCourier", 
						"nameClient",
						"phoneClient",
						"aPoint",
						"bPoint",
						"cPoint",
						"dPoint",
						"returnToOrigin",
						"estimatedTime",
						"paymentMethod",
						"value",
						"courierValue",
						"paymentCourierStatus"
					]}
				/>
            </div>
		);
	}

});

module.exports = List;


// WEBPACK FOOTER //
// ./src/components/Admin/Requests/List.jsx